module.exports = __webpack_public_path__ + "static/media/illo_scared.45f01b99.png";